import { UserGuard } from '../core/guards/user.guard';
import { Routes } from '@angular/router';
import { MerchantGuard } from '../core/guards/merchant.guard';
import { RoleAdminGuard } from '../core/guards/role.admin.guard';

export const clientEditorRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./client-editor/client-editor.component').then(m => m.ClientEditorComponent),
    canActivate: [UserGuard, RoleAdminGuard, MerchantGuard],
  },
  {
    path: 'options',
    loadComponent: () => import('./client-editor/client-editor.component').then(m => m.ClientEditorComponent),
    canActivate: [UserGuard, RoleAdminGuard, MerchantGuard],
    data: { state: 'options' },
  },
];

